import { useState } from 'react'

import { customPost } from '../utils/customFetch.ts'

import { makeUrlConsignmentPrice } from './connectionData.tsx'
import { useAuth } from './useAuth.tsx'

const apiUrl = makeUrlConsignmentPrice()
const useConsignmentPrice = () => {
  const [errorConsignmentPrice, setErrorConsignmentPrice] = useState<Error | null>(null)
  const [loading, setLoading] = useState<boolean>(false)
  const { userData } = useAuth()

  const consignmentPrice = async (_id: string, price: number) => {
    setLoading(true)

    try {
      const by = userData?.profile?._id ?? ''
      const res = await customPost<{ _id: string }>(apiUrl, { _id, by, price })
      setErrorConsignmentPrice(null)

      return res._id
    } catch (err) {
      // Assert the error as an instance of Error
      setErrorConsignmentPrice(err instanceof Error ? err : new Error('An unknown error occurred'))
    } finally {
      setLoading(false)
    }
  }

  // Exponemos estas variables al exterior
  return { errorConsignmentPrice, loading, consignmentPrice }
}
export default useConsignmentPrice
